export default __webpack_public_path__ + "static/media/flag-lao-people's-democratic-republic.2aa72319.svg";